import React, { useState, useRef, useEffect } from 'react';
import { TextField, Button, Typography, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router-dom'
import { checkInvitationCode } from '../services/apiService';
import LoadingSpinner from './LoadingSpinner';
import LogoTitle from './LogoTitle';



const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
    },
    label: {
        fontWeight: 'bold',
        fontSize: '18px',
    },
    inputContainer: {
        display: 'flex',
        gap: '8px',
        margin: '20px',
    },
    input: {
        width: '48px',
        height: '50px',
        fontSize: '24px',
        textAlign: 'center',
        '& input': {
            textAlign: 'center',
            fontSize: '24px',
        },
    },
    errorText: {
        color: 'red',
        fontSize: '14px',
    },
}));

const InvitationCodeInput = ({ onSubmit, formError, showLogin }) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [code, setCode] = useState(['', '', '', '', '', '']);
    const [error, setError] = useState(formError);
    const inputRefs = useRef([]);
    const location = useLocation(); // Use useLocation to get the current URL

    useEffect(() => {
        inputRefs.current[0].focus(); // Focus on the first input box when the component mounts

        // Check for code query parameter in the URL
        const params = new URLSearchParams(location.search);
        const queryCode = params.get('code');

        if (queryCode && /^\d{6}$/.test(queryCode)) {
            setCode(queryCode.split(''));
            setError('');
        }
    }, [location.search]);

    const handleChange = (index, value) => {
        if (!/^[0-9]?$/.test(value)) return; // Only allow numbers

        let newCode = [...code];
        newCode[index] = value;
        setCode(newCode);

        if (value !== '' && index < 5) {
            inputRefs.current[index + 1].focus(); // Auto-focus next input
        }
    };

    const handlePaste = (event) => {
        event.preventDefault();
        const pasteData = event.clipboardData.getData('text').trim();

        if (pasteData.length !== 6 || !/^\d{6}$/.test(pasteData)) {
            setError('Invalid code! Please enter exactly 6 numeric characters.');
            return;
        }

        setCode(pasteData.split(''));
        setError('');
    };

    const handleSubmit = async () => {
        if (code.includes('')) {
            setError('Please complete all 6 fields.');
            return;
        }

        const finalCode = code.join('');
        if (!/^\d{6}$/.test(finalCode)) {
            setError('Invalid code! Please enter numbers only.');
            return;
        }

        onSubmit(finalCode);
        setError(''); // Clear error upon success
    };

    return (
        <Box>

            <Typography variant="h6" sx={{ marginBottom: '20px' }}>Closed Beta Invitation</Typography>{' '}
            <Typography>
                <span>Please enter your</span>{' '}
                <span className={classes.label}>6 digit</span> invitation code:
            </Typography>
            <Box className={classes.inputContainer}>
                {code.map((char, index) => (
                    <TextField
                        key={index}
                        variant="outlined"
                        className={classes.input}
                        value={char}
                        inputProps={{ maxLength: 1 }}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onPaste={handlePaste}
                        inputRef={(el) => (inputRefs.current[index] = el)}
                    />
                ))}
            </Box>
            {error && <Typography className={classes.errorText}>{error}</Typography>}
            <Button fullWidth variant="contained" color="primary" sx={{ marginTop: 8 }} onClick={handleSubmit}>
                Submit
            </Button>
        </Box>
    );
};

export default InvitationCodeInput;
